import React from 'react';
import { Box } from '@mui/material';

const Space = ({ 
  size = 'medium',
  direction = 'vertical',
  ...props 
}) => {
  // Définir les tailles d'espacement
  const sizes = {
    xs: { xs: 1, md: 1 },
    small: { xs: 2, md: 3 },
    medium: { xs: 4, md: 6 },
    large: { xs: 6, md: 8 },
    xl: { xs: 8, md: 10 },
  };

  // Choisir la propriété CSS selon la direction
  const spacingProp = direction === 'horizontal' ? 'px' : 'py';

  return (
    <Box 
      sx={{ 
        [spacingProp]: sizes[size] || sizes.medium 
      }} 
      {...props} 
    />
  );
};

export default Space; 